export const STATUS = [
  {
    text: 'Outstanding Internal & Customer',
    value: '',
    color: '#F4AF00'
  },
  {
    text: 'Outstanding Internal',
    value: '',
    color: '#2F80ED'
  },
  {
    text: 'Outstanding Customer',
    value: '',
    color: '#2D9CDB'
  },
  {
    text: 'Closed',
    value: '',
    color: '#219653'
  },
]

export const DETAIL_STATUS = [
  {
    text: 'Investigation Request - Need Revision',
    value: '',
    color: '#F4002C'
  },
  {
    text: 'Settlement - Need Revision',
    value: '',
    color: '#F4002C'
  },
  {
    text: 'Outstanding - Need Revision',
    value: '',
    color: '#F4002C'
  },
  {
    text: 'Outstanding - Cancel',
    value: '',
    color: '#F4002C'
  },
  {
    text: 'Outstanding Internal - Waiting for Verification',
    value: '',
    color: '#F4AF00'
  },
  {
    text: 'Investigation Request - Need Revision',
    value: '',
    color: '#F4002C'
  },
  {
    text: 'Investigation Internal Issue - Waiting Approval',
    value: '',
    color: '#9B51E0'
  },
  {
    text: 'Settlement - Waiting Approval',
    value: '',
    color: '#F4AF00'
  },
  {
    text: 'Outstanding',
    value: '',
    color: '#F4AF00'
  },
  {
    text: 'Closed',
    value: '',
    color: '#219653'
  },
]

export const getStatusColor = (text, source, fallbackColor = '#000000') => {
  return source.find((item) => item.text === text)?.color || fallbackColor;
};
